import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';

@Injectable({
  providedIn: 'root'
})
export class ChallanService extends BaseService{

  constructor(private http: HttpClient, tokenService: TokenService) {
    super(tokenService);
}
  // GET SERVICES
  getDataToPrintChallan(appId: any, progId: any){
    return this.http.get<any>(`${environment.apiUrl}Challan/GetDataToPrintChallan?AppId=${appId}&ProgId=${progId}`, { headers: this.buildHeaders() });
  }

  getSolarChallan(appId: any){
    return this.http.get<any>(`${environment.apiUrl}Challan/GetSolarChallan?AppId=${appId}`, { headers: this.buildHeaders() });
  }

  getFarmerSolarDetails(appId: any){
    return this.http.get<any>(`${environment.apiUrl}FarmerApplication/GetFarmerSolarDetails?AppId=${appId}`, { headers: this.buildHeaders() });
  }

  getApplicationIdsForChallan(reqBody :any){
    return this.http.post<any>(`${environment.apiUrl}Challan/GetApplicationIdsForChallan`, reqBody);
  }

  getApplicationIdsForSolarChallan(reqBody: any){
    return this.http.post<any>(`${environment.apiUrl}Challan/GetApplicationIdsForSolarChallan`, reqBody);
  }

  
  getSanctionLetterData(appId, ProgID){
    return this.http.get<any>(`${environment.apiUrl}Challan/GetSanctionLetterData?AppId=${appId}&ProgID=${ProgID}`, { headers: this.buildHeaders() });
  }


  //POST SERVICES
  insertChallanData(reqBody:any){
    return this.http.post<any>(`${environment.apiUrl}Challan/InsertChallanData`, reqBody, { headers: this.buildHeaders() });
  }
  
}
